import { render, staticRenderFns } from "./enterpriseAI.vue?vue&type=template&id=12b3555f&scoped=true"
import script from "./enterpriseAI.vue?vue&type=script&lang=js"
export * from "./enterpriseAI.vue?vue&type=script&lang=js"
import style0 from "./enterpriseAI.vue?vue&type=style&index=0&id=12b3555f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3555f",
  null
  
)

export default component.exports